import { LiteUIContext } from '@/contexts/LiteUIContext';
import { useContext, useMemo } from 'react';
export const FPSBar = () => {
    const { fps, isFpsRunning, averageFPS } = useContext(LiteUIContext);
    const color = useMemo(() => {
        if (fps < 20) {
            return 'red';
        }
        if (fps < 30) {
            return 'orange';
        }
        if (fps < 40) {
            return 'yellow';
        }
        return 'green';
    }, [fps]);
    const averageColor = useMemo(() => {
        if (!averageFPS) {
            return '';
        }
        if (averageFPS < 15) {
            return 'red';
        }
        if (averageFPS < 30) {
            return 'orange';
        }
        if (averageFPS < 40) {
            return 'yellow';
        }
        return 'green';
    }, [averageFPS]);
    return isFpsRunning ? (
        <div
            style={{
                pointerEvents: 'none',
                position: 'absolute',
                top: '0px',
                zIndex: 10000,
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                lineHeight: 1,
            }}
        >
            <div
                style={{
                    color: color,
                }}
            >{`${fps}fps`}</div>
            {averageFPS && (
                <div
                    style={{
                        color: averageColor,
                    }}
                >{`${averageFPS}fps`}</div>
            )}
        </div>
    ) : (
        <></>
    );
};
